import { CheckIcon, CopyIcon } from 'components/icons';
import { Button } from 'components/ui/button';
import { CopiedStatus } from 'components/util/CopiedStatus';
import { useCopied } from '../../../hooks/useCopied';

interface Props {
    /** What the button copies: "Copy table as CSV", "Copy chart". */
    label: string;
    /** The name of a copy button repeated in one Figure: its label, then what it copies for. */
    accessibleName?: string;
    /** Puts the copy on the clipboard. Called on the click itself, which Safari needs to keep its permission. */
    copy: () => Promise<void>;
}

/** A Figure's copy button: its icon swaps to a check for a moment, its label stays. */
export function FigureCopyButton({ label, accessibleName, copy }: Props) {
    const [copied, markCopied] = useCopied();

    return (
        <>
            <Button
                variant="ghost"
                aria-label={accessibleName}
                className="text-meta text-foreground-secondary h-8 gap-1.5 rounded-md ps-2 pe-2.5 font-medium"
                onClick={() => {
                    copy().then(markCopied, (error: unknown) => console.error('Failed to copy:', error));
                }}
            >
                <span className="t-icon-swap size-3.5" data-state={copied ? 'b' : 'a'} aria-hidden="true">
                    <span className="t-icon" data-icon="a">
                        <CopyIcon className="size-3.5" />
                    </span>
                    <span className="t-icon text-success-ink" data-icon="b">
                        <CheckIcon className="size-3.5" />
                    </span>
                </span>
                {label}
            </Button>
            <CopiedStatus copied={copied} />
        </>
    );
}
